import KashubianFlag from '../assets/icons/flags/kashubian.png';
import SilesianFlag from '../assets/icons/flags/silesian.png';

type FlagReturn = {
  type: 'iso' | 'local';
  value: string;
}

export const countryFlagHelper = (language: string): FlagReturn => {
  switch (language) {
    case 'en':
      return { type: 'iso', value: 'GB' };
    case 'szl':
      return { type: 'local', value: SilesianFlag };
    case 'cbs':
      return { type: 'local', value: KashubianFlag };
    default:
      return { type: 'iso', value: language };
  }
};
